@if (!useButtonLook && !useButtonRaisedLook) {
  <a [routerLink]="routerLink" [queryParams]="queryParams" (click)="onClick($event)" (auxclick)="onClick($event)">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </a>
}
@if (useButtonLook) {
  <a [routerLink]="routerLink" [queryParams]="queryParams" mat-button [color]="buttonColor" (click)="onClick($event)" (auxclick)="onClick($event)">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </a>
}
@if (useButtonRaisedLook) {
  <a [routerLink]="routerLink" [queryParams]="queryParams" mat-raised-button [color]="buttonColor" (click)="onClick($event)" (auxclick)="onClick($event)">
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  </a>
}

<!-- Template-->
<ng-template #contentTpl><ng-content></ng-content></ng-template>
